export default __webpack_public_path__ + "static/beads-ccb7411501b03cda18336a895399d149.png";